import { logError } from './logging';

export enum LocalStorageKeys {
  // Checkout-wide
  CheckoutRedirectReason = 'redirect-reason',
  CheckoutSubBasketItems = 'subbasket-items',
  CheckoutCustomerReview = 'cusReview',
  CheckoutDeliveryExperience = 'delivery-experience',
  CartUpdated = 'cart-updated',
  CartNotifications = 'cart-notifications',

  // Shipping options and checkout
  ShippingMethod = 'shipping-method',
  ShippingSavedAddress = 'shipping-saved-address',
  ShippingPreviousAddress = 'shipping-prev-address2',
  ShippingDeliveryInput = 'shipping-d-input',
  ShippingDeliveryOption = 'shipping-d-option',
  ShippingDeliveryAddress = 'shipping-d-address',
  ShippingDeliveryType = 'shipping-d-deliverytype',
  ShippingDeliveryIsManualAddress = 'shipping-d-ismanualaddress',
  ShippingDeliveryIsBusinessAddress = 'shipping-d-isbusinessaddress',
  ShippingParcelLockerInput = 'shipping-pl-input',
  ShippingParcelLockerOption = 'shipping-pl-option',
  ShippingParcelLockerLocationId = 'shipping-pl-locationid',
  ShippingParcelLockerDeliveryType = 'shipping-pl-deliverytype',
  ShippingClickAndCollectInput = 'shipping-cnc-input',
  ShippingClickAndCollectStoreId = 'shipping-cnc-storeid',
  ShippingClickAndCollectFirstName = 'ccFirstName',
  ShippingClickAndCollectLastName = 'ccLastName',
  ShippingClickAndCollectMobile = 'ccMobile',
  ShippingCurrentTab = 'current-tab',
  ShippingPageValidation = 'page-validation',
  ShippingUpdated = 'shipping-updated',

  // Fulfilment container
  FulfilmentValidationResult = 'fulfilmentValidationResult',

  // Availaibility
  AvailabilityPostcode = 'Availability-Postcode',
  AvailabilitySuburb = 'Availability-Suburb',

  // Google Rec
  RecToken = 'gRecTokenHomepage',
  RecTokenRelated = 'gRecTokenRelated',

  // Cart
  GiftCardAppliedAmount = 'gift_card_applied_amount',
  MySelectedStore = 'my-selected-store',

  // Search
  RecentSearches = 'recentSearches',
  RecentlyViewed = 'recentlyViewed',

  // Snackbars
  DismissedSnackbars = 'dismissedSnackbars',

  // Coupons
  ShouldShowSpendAndGetBanner = 'shouldShowSpendAndGetBanner',
  SpendAndGetAutoClosed = 'spendAndGetAutoClosed',
}

//
// Functions for local storage actions
//

/**
 * Set to localStorage
 */
export function setLocal(key: LocalStorageKeys, data: any, isJson = false) {
  if (!window.localStorage) {
    return;
  }

  try {
    localStorage.setItem(key, isJson ? JSON.stringify(data) : data);
  } catch (e) {
    logError(e, 'Saving to localstorage failed');
  }
}

/**
 * Get from localStorage
 */
export function getLocal(key: LocalStorageKeys, isJson = false) {
  if (!window.localStorage) {
    return '';
  }

  let data: any;
  try {
    data = localStorage.getItem(key);
    if (isJson) {
      data = JSON.parse(data);
    }
  } catch (e) {
    logError(e, 'Getting from localstorage failed');
  }

  return data;
}

/**
 * Remove localStorage
 */
export function removeLocal(key: LocalStorageKeys) {
  if (!window.localStorage) {
    return;
  }

  localStorage.removeItem(key);
}

/**
 * Add to localStorage set
 */
export function addToLocalSet(key: LocalStorageKeys, data: any) {
  if (!window.localStorage) {
    return;
  }

  const existing = getLocal(key, true) || [];
  if (Array.isArray(existing)) {
    const set = new Set(existing);
    set.add(data);
    setLocal(key, Array.from(set), true);
  } else {
    setLocal(key, [data], true);
  }
}
